import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {checklistItems, feedbacks, pointsCreatedWebsite, whyNeedPoints} from '../moveTo10WebcontentData';

@Component({
    selector: 'db-move-to10web-connected',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './move-to10web-connected.component.html',
    styleUrls: ['./move-to10web-connected.component.scss'],
    standalone: false
})
export class MoveTo10webConnectedComponent {

  @Input() public desktopScore: number;
  @Output() public migrate = new EventEmitter<void>();
  public checklistItems = checklistItems;
  public pointsCreatedWebsite = pointsCreatedWebsite;
  public whyNeedPoints = whyNeedPoints;
  public feedbacks = feedbacks;

  constructor() { }

}
